exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".body{background-color:#fff;padding:10pt;overflow:hidden}.highlight{background-color:#01809e!important}.highlight a{color:#fff!important}.el-date-editor .el-range-separator{padding:0}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/Reports.vue"],"names":[],"mappings":"AACA,MACE,sBAAwB,AACxB,aAAc,AACd,eAAiB,CAClB,AACD,WACE,kCAAqC,CACtC,AACD,aACE,oBAAwB,CACzB,AACD,oCACE,SAAW,CACZ","file":"Reports.vue","sourcesContent":["\n.body {\n  background-color: white;\n  padding: 10pt;\n  overflow: hidden;\n}\n.highlight {\n  background-color: #01809E !important;\n}\n.highlight a {\n  color: white !important;\n}\n.el-date-editor .el-range-separator{\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78525e2d","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Reports.vue
// module id = 928
// module chunks = 6